export interface Region {
  name: string
  logo: string
  plan: string
  apiBaseUrl: string
  consoleApiHost?: string
  envKey: string
  prod: boolean
}

// In dev, route all API calls through the Vite proxy (configured in
// vite.config.ts) so the browser sees a same-origin response — required for
// upstream HTTPS cookies to be accepted on the http://localhost origin.
function devOrAbsolute(envKey: string, absolute: string): string {
  return import.meta.env.DEV ? `/proxy-api/${envKey}` : absolute
}

const allRegions: Region[] = [
  {
    name: '中国',
    logo: 'i-lucide-flag',
    plan: 'China',
    prod: true,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL_CN || 'https://console.spatialwalk.top',
    consoleApiHost: 'https://console.open.spatialwalk.top',
    envKey: 'cn',
  },
  {
    name: '美国',
    logo: 'i-lucide-globe',
    plan: 'USA',
    prod: true,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL_US || 'https://api.openplatform.spatialwalk.cloud',
    consoleApiHost: 'https://console.us-west.spatius.ai',
    envKey: 'us',
  },
  {
    name: '测试',
    logo: 'i-lucide-bug',
    plan: 'Test',
    prod: false,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL_TEST || devOrAbsolute('test', 'https://console-test.spatialwalk.top'),
    consoleApiHost: devOrAbsolute('test', 'https://console-test.spatialwalk.top'),
    envKey: 'test',
  },
  {
    name: '开发',
    logo: 'i-lucide-code',
    plan: 'Dev',
    prod: false,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL_DEV || devOrAbsolute('dev', 'http://localhost:8083'),
    consoleApiHost: devOrAbsolute('dev', 'http://localhost:8083'),
    envKey: 'dev',
  },
]

export const regions = allRegions.filter((region) => {
  const siteEnvironment = import.meta.env.VITE_ENV || (import.meta.env.DEV ? 'development' : 'production')
  // Deployed preview builds must use the remote Test backend. The Dev region
  // points at localhost and is only meaningful while running Vite locally.
  if (siteEnvironment === 'preview')
    return region.envKey === 'test'
  return siteEnvironment === 'production' ? region.prod : !region.prod
})
